module.exports = __webpack_public_path__ + "static/media/cover-3.35fb1fc1.jpg";